import styled from 'styled-components';
import { breakpoints, spacing } from '@naf/theme';
import { Accordion } from '@naf/accordion';

export const StyledAccordion = styled(Accordion)`
  border-color: rgba(255, 255, 255, 0.12);

  section {
    padding-bottom: ${spacing.space24} !important;
  }
`;

export const LinkList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;

  @media (max-width: ${breakpoints.m}) {
    margin: 0;
  }
`;
